/* BYON · carro: agregados de un toque, pago desde el carro lateral, barra de despacho y medición
   (agente Carro; R1 24-sep-2026). Se carga en todas las páginas desde sections/cart-drawer.liquid.
   - El contrato K2 (window.byonCart.refreshDrawer/openDrawer, 'byon:cart:updated', cambios externos) está en
     assets/cart-drawer.js. La lógica de la página /cart está en assets/byon-cart-page.js.
   - Agregados sin input[name="id"] (C1-CAR-02, K8): botón [data-byon-cart-add] → POST /cart/add.js en JSON.
   - Medición (K1): add_to_cart (cart_addon | cart_empty) y drawer_checkout_click (drawer), siempre protegida.
   - Cuota truncada igual que Venti: Math.floor(centavos / 300) * 100 (C1-CAR-04).
   - Ronda 11 (Bloque C, 25-sep-2026), K12: con el interruptor webpay_activo, la cuota de Webpay usa la misma fórmula
     que snippets/byon-pay-line.liquid: Math.ceil(centavos / 300) * 100 (techo al peso; calza con Webpay ±$1).
     Los montos con data-byon-round="up" usan esa fórmula; los demás siguen truncados (Venti, ronda 10).
     [data-byon-payline] alterna "o 3 cuotas de $X sin interés…" y "o 3 cuotas sin interés" según data-byon-desde.
     window.byonCart.payInfo() y payText(centavos, contexto, disponible) exponen el modo y los textos canónicos
     (contextos 'qa' y 'card') para la compra rápida y otras piezas en JS: devuelven null con Webpay apagado, y
     entonces cada pieza deja su texto de ronda 10. El modo sale de <cart-drawer data-byon-pay…>.
   - R1 (26-sep-2026): bajo cuota_desde, 'qa' devuelve "Desde $50.000: 3 cuotas sin interés con crédito (Webpay)"
     (D-06; sin "hasta" ni "te faltan"). La barra pinta el tramo de regalo recién desde data-gift-from (GC 15:
     regalo_umbral − $20.000 = $79.990) y muestra u oculta las piezas [data-byon-tier] como el servidor.
   - R2 (26-sep-2026): "3 cuotas sin interés" a secas (decisión de Pablo): payText devuelve "3 cuotas de $X sin interés"
     (+ " · CAE 0% · Costo total $Y"; en 'card', + " · CAE 0%") desde cuota_desde y "3 cuotas sin interés" bajo ese
     monto, sin "crédito", "débito", "(Webpay)" ni "desde $50.000". El tramo de regalo nunca parte antes del despacho
     gratis: desde = máx(data-gift-from, data-free) (R2-TEC-06), igual que snippets/byon-cart-progress.liquid.
   - R3 (26-sep-2026, R3-UX-02): en la tarjeta ('card') y la compra rápida ('qa'), payText devolvía "3 cuotas sin
     interés" en todos los precios, sin monto. Otros contextos siguen con la cuota, CAE y costo total desde
     cuota_desde, como la ficha y el carro.
   - R4 (8-oct-2026, pedido de Pablo): el monto sale siempre. payText devuelve "3 cuotas de $X sin interés" en todos
     los precios ('card' sin CAE; los demás con " · CAE 0% · Costo total $Y" si cae_activo). La línea del carro trae
     data-byon-desde="1", así que updateTotals deja visible el monto con cualquier total. */
(() => {
  const B = (window.byonCart = window.byonCart || {});
  if (B.ready) return;
  B.ready = true;

  const track = (name, data) => {
    try {
      (window.byonTrack || function () {})(name, data);
    } catch (error) {
      /* la medición nunca bloquea la compra */
    }
  };
  B.track = track;
  const pesos = (cents) => Math.round((Number(cents) || 0) / 100);
  B.pesos = pesos;
  B.money = (cents) => `$${pesos(cents).toLocaleString('es-CL')}`;
  B.cuota = (cents) => Math.floor((Number(cents) || 0) / 300) * 100;
  B.cuotaUp = (cents) => Math.ceil((Number(cents) || 0) / 300) * 100;
  B.payInfo = () => {
    const el = document.querySelector('cart-drawer[data-byon-pay]');
    if (!el || el.dataset.byonPay !== 'webpay') return null;
    return {
      mode: 'webpay',
      desde: Number(el.dataset.byonPayDesde) || 0,
      cae: el.dataset.byonPayCae === 'true',
      hasta: el.dataset.byonPayHasta === 'true',
    };
  };
  B.payText = (cents, context, available) => {
    const info = B.payInfo();
    if (!info) return null;
    const total = Number(cents) || 0;
    if (available === false || total <= 0) return '';
    // R4 (8-oct-2026, Pablo): el monto de la cuota sale siempre, en todos los precios y contextos.
    const cuota = `3 cuotas de ${B.money(B.cuotaUp(total))} sin interés`;
    if (context === 'card') return cuota;
    return `${cuota}${info.cae ? ` · CAE 0% · Costo total ${B.money(total)}` : ''}`;
  };
  const markOwn = () => {
    if (typeof B.markOwn === 'function') B.markOwn();
    else B._own = Date.now();
  };
  const getRoutes = () => window.routes || { cart_url: '/cart', cart_add_url: '/cart/add' };
  const escapeHtml = (value) =>
    String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const isCartPage = () => !!document.getElementById('main-cart-items');
  const getDrawer = () => document.querySelector('cart-drawer');
  B.sigParts = (sig) => {
    const parts = String(sig || '').split('|');
    return { count: Number(parts[0]) || 0, total: Number(parts[1]) || 0 };
  };

  /* 1. Scripts heredados: desplegable-comunas declara comunascon sin valor en páginas sin despacho-express. */
  try {
    // eslint-disable-next-line no-undef
    if (!Array.isArray(comunascon)) comunascon = [];
  } catch (error) {
    /* comunascon no está declarado: nada que proteger */
  }

  /* 2. Barra de despacho gratis (mismo cálculo que snippets/byon-cart-progress.liquid). */
  B.renderProgress = (el, total) => {
    const free = Number(el.dataset.free) || 0;
    const gift = Number(el.dataset.gift) || 0;
    const giftOn = el.dataset.giftOn === 'true' && gift > free;
    const tier = giftOn && total >= Math.max(Number(el.dataset.giftFrom) || 0, free);
    const max = tier ? gift : free;
    if (!max) return;
    let state = 'none';
    let missing = 0;
    let template = el.dataset.tFree || '';
    if (total < free) {
      missing = free - total;
    } else if (tier && total < gift) {
      state = 'free';
      missing = gift - total;
      template = el.dataset.tGift || '';
    } else if (tier) {
      state = 'gift';
      template = el.dataset.tDone || '';
    } else {
      state = 'free';
      template = el.dataset.tFreeDone || '';
    }
    const pct = Math.max(0, Math.min(100, Math.floor((total * 100) / max)));
    el.classList.remove('byon-cart-progress--none', 'byon-cart-progress--free', 'byon-cart-progress--gift');
    el.classList.add(`byon-cart-progress--${state}`);
    if (giftOn) {
      el.classList.toggle('byon-cart-progress--two', tier);
      el.querySelectorAll('[data-byon-tier]').forEach((node) => {
        node.hidden = (node.dataset.byonTier === 'on') !== tier;
      });
    }
    const msg = el.querySelector('[data-byon-cart-progress-msg]');
    if (msg) msg.innerHTML = escapeHtml(template).replace('[monto]', `<b>${B.money(missing)}</b>`);
    const fill = el.querySelector('.byon-cart-progress__fill');
    if (fill) fill.style.width = `${pct}%`;
    const track2 = el.querySelector('[role="progressbar"]');
    if (track2) {
      track2.setAttribute('aria-valuenow', String(pct));
      track2.setAttribute('aria-valuetext', template.replace('[monto]', B.money(missing)));
    }
    el.dataset.total = String(total);
  };

  B.updateTotals = (cart) => {
    if (!cart) return;
    document.querySelectorAll('[data-byon-cart-progress]').forEach((el) => B.renderProgress(el, cart.total_price));
    document.querySelectorAll('[data-byon-cart-total]').forEach((el) => {
      el.textContent = B.money(cart.total_price);
    });
    document.querySelectorAll('[data-byon-cart-cuota]').forEach((el) => {
      const up = el.dataset.byonRound === 'up';
      el.textContent = B.money(up ? B.cuotaUp(cart.total_price) : B.cuota(cart.total_price));
    });
    document.querySelectorAll('[data-byon-payline]').forEach((el) => {
      const withAmount = cart.total_price >= (Number(el.dataset.byonDesde) || 0);
      const amount = el.querySelector('[data-byon-pay-amount]');
      const generic = el.querySelector('[data-byon-pay-generic]');
      if (amount) amount.hidden = !withAmount;
      if (generic) generic.hidden = withAmount;
    });
  };

  let syncSeq = 0;
  B.syncTotals = () => {
    const current = ++syncSeq;
    return fetch(`${getRoutes().cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        if (current === syncSeq) B.updateTotals(cart);
        return cart;
      })
      .catch(() => null);
  };

  /* 3. Cualquier elemento con data-byon-cart-open abre el carro lateral. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest ? event.target.closest('[data-byon-cart-open]') : null;
    if (!trigger || !getDrawer()) return;
    event.preventDefault();
    if (typeof B.openDrawer === 'function') B.openDrawer(trigger);
  });

  /* 4. Agregados de un toque ("La combinan con" y carro vacío). */
  function announce(message) {
    const region = document.getElementById('CartDrawer-LiveRegionText');
    if (!region) return;
    region.textContent = '';
    setTimeout(() => {
      region.textContent = message;
    }, 60);
  }

  function showAddonError(button, message) {
    const card = button.closest('.byon-cart-addon') || button.parentElement;
    if (!card) return;
    let error = card.querySelector('.byon-cart-addon__error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'byon-cart-addon__error';
      error.setAttribute('role', 'alert');
      card.appendChild(error);
    }
    error.textContent = message;
  }

  function focusLine(drawer, variantId) {
    const link =
      drawer.querySelector(`.byon-cart-line[data-variant-id="${variantId}"] .cart-item__name`) ||
      drawer.querySelector('.drawer__inner');
    const container = drawer.classList.contains('is-empty')
      ? drawer.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    if (container && link && typeof trapFocus === 'function') trapFocus(container, link);
    else if (link) link.focus();
  }

  function addFromButton(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;
    const drawer = getDrawer();
    const card = button.closest('.byon-cart-addon');
    const select = card ? card.querySelector('[data-byon-cart-variant]') : null;
    const variantId = String((select && select.value) || button.dataset.variantId || '');
    if (!variantId) return;
    const option = select && select.selectedOptions ? select.selectedOptions[0] : null;
    const price = Number((option && option.dataset.price) || button.dataset.price) || 0;
    const name = button.dataset.name || 'Producto';
    const source = button.dataset.source === 'cart_empty' ? 'cart_empty' : 'cart_addon';
    const originalHTML = button.innerHTML;
    const restore = () => {
      if (!button.isConnected) return;
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
      button.innerHTML = originalHTML;
    };

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    button.textContent = 'Agregando…';
    const oldError = card ? card.querySelector('.byon-cart-addon__error') : null;
    if (oldError) oldError.remove();

    markOwn();
    fetch(`${getRoutes().cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || !data || data.status) {
          showAddonError(button, (data && (data.description || data.message)) || 'No pudimos agregar el producto.');
          restore();
          return;
        }
        track('add_to_cart', {
          atc_source: source,
          item_id: String(button.dataset.productId || ''),
          variant_id: variantId,
          item_name: name,
          price: pesos(price),
          quantity: 1,
          currency: 'CLP',
        });
        if (isCartPage() || !drawer || typeof drawer.applySections !== 'function') {
          window.location.reload();
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'byon-cart', productVariantId: variantId });
        }
        drawer.applySections(data.sections);
        drawer.skipVerify = true;
        announce(`${name}: agregado al carro.`);
        if (drawer.classList.contains('active')) focusLine(drawer, variantId);
        else drawer.open();
      })
      .catch((error) => {
        console.error('[BYON carro]', error);
        showAddonError(button, 'No pudimos agregar el producto. Inténtalo de nuevo.');
        restore();
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest ? event.target.closest('[data-byon-cart-add]') : null;
    if (!button) return;
    event.preventDefault();
    addFromButton(button);
  });

  /* 5. "Ir a pagar" del carro lateral: va directo al checkout (POST /cart con checkout). Si el cliente ya eligió
        su comuna en el header, se envía igual que desde /cart. Mide drawer_checkout_click antes de enviar. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'CartDrawer-Form') return;
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    try {
      const region = localStorage.getItem('region');
      const comuna = localStorage.getItem('comuna');
      if (region && comuna) {
        form.setAttribute(
          'action',
          `${getRoutes().cart_url}?step=contact_information&checkout[shipping_address][country]=CL&checkout[shipping_address][province]=${encodeURIComponent(region)}&checkout[shipping_address][city]=${encodeURIComponent(comuna)}`
        );
      }
    } catch (error) {
      /* localStorage bloqueado: se usa /cart */
    }
    const state = document.querySelector('cart-drawer [data-byon-cart-sig]');
    const totals = B.sigParts(state ? state.dataset.byonCartSig : '');
    track('drawer_checkout_click', {
      value: pesos(totals.total),
      currency: 'CLP',
      item_count: totals.count,
      checkout_source: 'drawer',
    });
    submitter.classList.add('is-loading');
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.byon-cart-btn--pay.is-loading').forEach((button) => button.classList.remove('is-loading'));
  });
})();
